import style from "./Layout.module.css";
import { Progress } from "./Progress";

export const Layout: React.FC<React.PropsWithChildren<{

    drawing?: boolean

}>> = ({ children }) => {

    return <div
        className={style.container}
    >

        <Progress />

        {children}
    </div>

}